import React from "react";
import {
  Tooltip as AriaTooltip,
  TooltipTrigger as AriaTooltipTrigger,
  TooltipProps as AriaTooltipProps,
} from "react-aria-components";
import { twMerge } from "tailwind-merge";

export interface TooltipProps extends Omit<AriaTooltipProps, "children"> {
  children: React.ReactNode;
  className?: string;
}

export interface TooltipTriggerProps {
  children: React.ReactNode;
  delay?: number;
  closeDelay?: number;
  shouldCloseOnPress?: boolean;
}

export function TooltipTrigger({
  children,
  delay = 0,
  closeDelay = 0,
  shouldCloseOnPress,
}: TooltipTriggerProps) {
  return (
    <AriaTooltipTrigger
      delay={delay}
      closeDelay={closeDelay}
      shouldCloseOnPress={shouldCloseOnPress}>
      {children}
    </AriaTooltipTrigger>
  );
}

export function Tooltip({ children, className, ...props }: TooltipProps) {
  return (
    <AriaTooltip
      {...props}
      className={twMerge(
        "px-2 py-1 text-pm bg-contentPrimary text-backgroundPrimary rounded-md shadow-md data-entering:animate-in data-entering:fade-in data-exiting:animate-out data-exiting:fade-out duration-base ease-out",
        className,
      )}>
      {children}
    </AriaTooltip>
  );
}
